import { SentHistoryResult } from 'src/app/search/sent-history/sent-history.model';

export const mockSentHistory: SentHistoryResult = {
  totalTime: 5,
  ePolicyId: 234,
  ePolicyHistoryRecords: [
    {
      logId: 1,
      emailTo: ['azthtest@gmail.com', 'tagdanai.sujinnapram@allianz.com', 'hongfortest@gmail.com'],
      mobileNo: '08xxxx1180',
      sendDate: '2019-08-21T10:47:52.077+0000',
      sendBy: 'arpornrat'
    },
    {
      logId: 2,
      emailTo: ['azthtest@gmail.com', 'hongfortest@gmail.com'],
      mobileNo: '08xxxx2280',
      sendDate: '2019-05-17T03:15:44.639+0000',
      sendBy: 'pariyakornbua'
    },
    {
      logId: 3,
      emailTo: ['azthtest@gmail.com'],
      mobileNo: '08xxxx0080',
      sendDate: '2018-11-06T08:52:27.299+0000',
      sendBy: 'arpornrat'
    }
  ]
};
